import "./slider.css";
import PictureImage from '../Common/PictureImage';
import { IMAGE_ALT } from '../../seo/imageAltText';

type LogoEntry = {
  src: string;
  name: string;
};

const marketplaceLogos: LogoEntry[] = [
  { src: '/Images/merchent/amazon.webp', name: 'Amazon' },
  { src: '/Images/merchent/bigcommerce.webp', name: 'BigCommerce' },
  { src: '/Images/merchent/shopify.webp', name: 'Shopify' },
  { src: '/Images/merchent/woo.webp', name: 'WooCommerce' },
  { src: '/Images/merchent/etsy.webp', name: 'Etsy' },
  { src: '/Images/merchent/ebay.webp', name: 'eBay' },
  { src: '/Images/merchent/tiktok.webp', name: 'TikTok Shop' },
  { src: '/Images/merchent/wayfair.webp', name: 'Wayfair' },
  { src: '/Images/merchent/wowcher.webp', name: 'Wowcher' },
  { src: '/Images/merchent/groupon.webp', name: 'Groupon' },
];

const courierLogos: LogoEntry[] = [
  { src: '/Images/couriers/amazonshipping.webp', name: 'Amazon Shipping' },
  { src: '/Images/couriers/dhl.webp', name: 'DHL' },
  { src: '/Images/couriers/ups.webp', name: 'UPS' },
  { src: '/Images/couriers/royal_mail.webp', name: 'Royal Mail' },
  { src: '/Images/couriers/dpd.webp', name: 'DPD' },
  { src: '/Images/couriers/fedex.webp', name: 'FedEx' },
  { src: '/Images/couriers/parcelforce.webp', name: 'Parcelforce Worldwide' },
  { src: '/Images/couriers/yodel.webp', name: 'Yodel' },
  { src: '/Images/couriers/evri.webp', name: 'Evri' },
];

const Slider = () => {
  const loopMarketplaceLogos = [...marketplaceLogos, ...marketplaceLogos, ...marketplaceLogos];
  const loopCourierLogos = [...courierLogos, ...courierLogos, ...courierLogos];

  return (
    <div className="slider-wrapper">
      {/* Logistics Slider */}
      <div className="slider-section">
        <div className="slider-eyebrow">
          <span className="slider-dash"></span>
          INTEGRATIONS
        </div>
        <h2 className="slider-heading">650+ Marketplaces <br/><span style={{ color: '#1A44E5' }}>& Courier Integrations</span></h2>
        <p className="slider-intro">
          Connect Amazon, Shopify, TikTok Shop, eBay, Etsy, Royal Mail, DPD, EVRi, and UPS through one platform. Our ecommerce fulfillment solution in the UK streamlines inventory management, order processing, tracking, and dispatch while giving businesses complete visibility across every sales channel.
        </p>
        <div className="slider">
          <div className="slide-track">
            {loopMarketplaceLogos.map((logo, i) => (
              <div className="slide-card" key={`${logo.src}-${i}`} aria-hidden={i >= marketplaceLogos.length}>
                <PictureImage
                  src={logo.src}
                  alt={IMAGE_ALT.homepageMarketplaceLogo(logo.name)}
                  loading="lazy"
                  decoding="async"
                  width={250}
                  height={100}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Courier Slider */}
      <div className="slider-section">
        <div className="slider">
          <div className="slide-track slide-track-reverse">
            {loopCourierLogos.map((logo, i) => (
              <div className="slide-card" key={`${logo.src}-${i}`} aria-hidden={i >= courierLogos.length}>
                <PictureImage
                  src={logo.src}
                  alt={IMAGE_ALT.homepageCourierLogo(logo.name)}
                  loading="lazy"
                  decoding="async"
                  width={250}
                  height={100}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slider;

